'use strict';

angular.module('far.camp')
    .controller('CampEditController', function ($window, autocomplete, Camp, form, showModalMessage) {
        var vm = {
            progress: true,
            submitted: false,
            show_error: false,
            camp: null,
            form: {},
            fields: form('camp'),
            constructor: function (camp) {
                if (camp) {
                    vm.form = Camp.get(camp, function () {
                        vm.progress = false;
                    });
                } else {
                    vm.form = Camp.new();
                    vm.progress = false;
                }
            },
            submit: function () {
                if (vm.submitted) {
                    return false;
                }

                vm.submitted = true;

                vm.form.save()
                    .then(function (response) {
                        document.location.href = Routing.generate('camp_events', {id: response.data.id});
                    }, function errorCallback(response) {
                        vm.submitted = false;
                    });
            },
            autoCompleteSelect: {
                country: null,
                region: null
            }
        };

        vm.fields
            .addField('name', 'text', {
                validators: {
                    required: true
                },
                options: {
                    placeholder: 'Название'
                }
            })
            .addField('country', 'uiSelect', {
                validators: {
                    required: false
                },
                options: {
                    onSelect: 'field.uiSelectOptions.onSelect($item, $model)',
                    class: 'form__ui-select width-650'
                },
                uiSelectOptions: {
                    matchTitle: '{{ $select.selected.name }} ',
                    choicesTitle: '{{ item.name }}',
                    match: {
                        placeholder: 'Страна',
                        allowClear: true
                    },
                    choices: {
                        repeat: 'item in field.items track by item.id',
                        refresh: 'field.uiSelectOptions.refreshAutoComplete($select.search, "Country", "country")',
                        refreshDelay: 0
                    },
                    refreshAutoComplete: autocomplete.refreshAutoComplete,
                    onSelect: function (item) {
                        if (item) {
                            vm.autoCompleteSelect.country = item.id;
                            vm.autoCompleteSelect.region = null;

                            vm.fields.$fields.region.items = [];

                            vm.form.country = item;
                        }
                    }
                }
            }, autocomplete.get('country'))
            .addField('region', 'uiTypeahead', {
                validators: {
                    required: false
                },
                options: {
                    class: 'form__item',
                    placeholder: 'Регион',
                    uibTypeahead: "row as row.name for row in field.refreshAutoComplete($viewValue, 'Region')"
                },
                fieldData: {
                    clearBtn: true,
                    refreshAutoComplete: function (name, term) {
                        return autocomplete.refreshAutoComplete(name, term, null, vm.autoCompleteSelect)
                    }
                }
            })
            .addField('phone', 'text', {
                validators: {
                    required: false
                },
                options: {
                    placeholder: 'Телефон'
                }
            })
            .addField('email', 'text', {
                validators: {
                    required: false
                },
                options: {
                    placeholder: 'E-mail'
                }
            })
            .addField('www_site', 'text', {
                validators: {
                    required: false
                },
                options: {
                    placeholder: 'Сайт'
                }
            })
            .addField('www_vk', 'text', {
                validators: {
                    required: false
                },
                options: {
                    placeholder: 'Вконтакте'
                }
            })
            .addField('www_fb', 'text', {
                validators: {
                    required: false
                },
                options: {
                    placeholder: 'Facebook'
                }
            })
            .addField('www_in', 'text', {
                validators: {
                    required: false
                },
                options: {
                    placeholder: 'Instagram'
                }
            })
            .addField('general_data', 'textarea', {
             
                options: {
                    redactor: true,
                    placeholder: 'Описание лагеря',
                    class: 'form__item'
                }
            })
            .addField('image', 'imageUpload', {
                validators: {
                    required: false
                },
                uploader: {
                    url: Routing.generate('api_upload_post_avatar', {thumb: 'avatar_relative'}),
                    autoUpload: true,
                    removeAfterUpload: true,
                    onWhenAddingFileFailed: function (item, filter) {
                        var message = filter.message ? filter.message : 'Невозможно загрузить файл на сервер';
                        showModalMessage(message);
                    },
                    onErrorItem: function () {
                        showModalMessage('Невозможно загрузить файл на сервер');
                    },
                    onSuccessItem: function (item, response) {
                        vm.form.image = response;
                    }
                }
            })
            .addField('director', 'text', {
                validators: {
                    required: false
                },
                options: {
                    placeholder: 'Директор'
                }
            });

        return vm;
    });